<template>
  <section id="Faqs"  class="py-[2rem] px-6 md:py-[4rem] md:pr-[2.14rem] md:pl-0 lg:scroll-mt-33 scroll-mt-55" aria-label="Frequently Asked Questions">
    <Heading :level="4" class="mb-6 text-center ">
      Frequent Questions
    </Heading>

    <div v-for="(faq, index) in localItems" :key="index" class="border-b border-black">
      <Button title="Expand FAQ" type="button" variant="secondary" theme="LIGHT" size="sm"
        class="cursor-pointer w-full flex items-center justify-between py-4 text-left shadow-none border-none !py-[1rem] !px-[0]"
        @click="toggleFaq(index)" :aria-expanded="faq.open" :aria-controls="`faq-panel-${index}`"
        aria-label="Toggle FAQ Answer" :id="`faq-button-${index}`">
        <span class="text-base text-black">
          {{ faq.question }}
        </span>

        <span class="text-3_5xl font-medium leading-none text-black">
          {{ faq.open ? '×' : '+' }}
        </span>
      </Button>

      <transition enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in" enter-from-class="max-h-0 opacity-0"
        enter-to-class="max-h-[300px] opacity-100" leave-from-class="max-h-[300px] opacity-100"
        leave-to-class="max-h-0 opacity-0">
        <div v-show="faq.open" class="overflow-hidden pb-4 text-base text-black" role="region"
          :id="`faq-panel-${index}`" :aria-labelledby="`faq-button-${index}`">
          <div v-html="faq.answer" class="prose prose-sm max-w-none" />
        </div>
      </transition>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Heading from '../../atom/heading.vue'
import Button from '../../atom/button.vue'
import type { FaqItem } from '~~/shared/types/common'

const props = defineProps<{
  items: FaqItem[]
}>()

const localItems = ref<FaqItem[]>([])

watch(
  () => props.items,
  (newVal) => {
    localItems.value = newVal.map((faq) => ({ ...faq }))
  },
  { immediate: true }
)

const toggleFaq = (index: number) => {
  localItems.value[index]!.open = !localItems.value[index]!.open
}

</script>
